export default "__VITE_ASSET__BTOI9IYD__"